import dashboardIcon from "../../assests/sideBar/dashboard-icon.svg";
import dashboardActiveIcon from "../../assests/sideBar/dashboard-active-icon.svg";
import paymentsIcon from "../../assests/sideBar/payments-icon.svg";
import paymentsActiveIcon from "../../assests/sideBar/payments-active-icon.svg";
import investmentsIcon from "../../assests/sideBar/investments-icon.svg";
import investmentsInactiveIcon from "../../assests/sideBar/investments-inactive-icon.svg";
import loansIcon from "../../assests/sideBar/loans-icon.svg";
import loansActiveIcon from "../../assests/sideBar/loans-active-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { pagesWithoutFooter } from "../../utils/constants";
import React from "react";
import { useTranslation } from "react-i18next";

const CommonFooter = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();

  const { setPageAction } = props.generalDataProps;

  const tUrl = (text) => {
    return t(text)?.replaceAll("  ", "-");
  };

  return (
    <>
      {!pagesWithoutFooter.includes(location.pathname) && (
        <footer className="common-footer">
          {window.location.pathname ===
          `/${tUrl("footer.dashboard")?.toLowerCase()}` ? (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.dashboard")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container-active">
                <img
                  className="footer-menu-icon"
                  alt="Dashboard Icon"
                  src={dashboardActiveIcon}
                />
              </div>
              <p className="fotter-menu-text-active">{t("footer.dashboard")}</p>
            </div>
          ) : (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.dashboard")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container">
                <img
                  className="footer-menu-icon"
                  alt="Dashboard Icon"
                  src={dashboardIcon}
                />
              </div>
              <p className="fotter-menu-text">{t("footer.dashboard")}</p>
            </div>
          )}
          {window.location.pathname ===
          `/${tUrl("footer.payments")?.toLowerCase()}` ? (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.payments")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container-active">
                <img
                  className="footer-menu-icon"
                  alt="Payments Icon"
                  src={paymentsActiveIcon}
                />
              </div>
              <p className="fotter-menu-text-active">{t("footer.payments")}</p>
            </div>
          ) : (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.payments")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container">
                <img
                  className="footer-menu-icon"
                  alt="Payments Icon"
                  src={paymentsIcon}
                />
              </div>
              <p className="fotter-menu-text">{t("footer.payments")}</p>
            </div>
          )}
          {window.location.pathname.includes(
            `/${tUrl("footer.investments")?.toLowerCase()}`,
          ) ? (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.investments")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container-active">
                <img
                  className="footer-menu-icon"
                  alt="Investmnts Icon"
                  src={investmentsIcon}
                />
              </div>
              <p className="fotter-menu-text-active">
                {t("footer.investments")}
              </p>
            </div>
          ) : (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.investments")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container">
                <img
                  className="footer-menu-icon"
                  alt="Investmnts Icon"
                  src={investmentsInactiveIcon}
                />
              </div>
              <p className="fotter-menu-text">{t("footer.investments")}</p>
            </div>
          )}
          {process.env.REACT_APP_NODE_ENV !== "production" &&
          window.location.pathname ===
            `/${tUrl("footer.loans")?.toLowerCase()}` ? (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.loans")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container-active">
                <img
                  className="footer-menu-icon"
                  alt="Loans Icon"
                  src={loansActiveIcon}
                />
              </div>
              <p className="fotter-menu-text-active">{t("footer.loans")}</p>
            </div>
          ) : process.env.REACT_APP_NODE_ENV !== "production" ? (
            <div
              onClick={() => {
                //clear any popup??
                setPageAction("");
                props.setPopupContentPosition("center");
                props.setPopupContent(null);

                props.setShowPopup(false);
                navigate(`/${tUrl("footer.loans")?.toLowerCase()}`);
              }}
              className="footer-menu"
            >
              <div className="footer-menu-icon-container">
                <img
                  className="footer-menu-icon"
                  alt="Loans Icon"
                  src={loansIcon}
                />
              </div>
              <p className="fotter-menu-text">{t("footer.loans")}</p>
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </footer>
      )}
    </>
  );
};

export default CommonFooter;
